import { useCallback, useRef } from 'react';

export const usePrintPSX = () => {
  const printFnRef = useRef<(() => void) | null>(null);

  const printPSXPage = useCallback(() => {
    printFnRef.current?.();
  }, []);

  const onPrintReady = useCallback((fn: () => void) => {
    printFnRef.current = fn;
  }, []);

  return { printPSXPage, onPrintReady };
};
